import { render } from "./DescontoMatricula.vue?vue&type=template&id=2b8681da&scoped=true"
import script from "./DescontoMatricula.vue?vue&type=script&lang=js"
export * from "./DescontoMatricula.vue?vue&type=script&lang=js"

import "./DescontoMatricula.vue?vue&type=style&index=0&id=2b8681da&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8681da"]])

export default __exports__